/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GraphAnnotationModel } from '../../models/graph-annotation-model';

export interface SaveGraphAnnotation$Params {
      body?: GraphAnnotationModel
}

export function SaveGraphAnnotation(http: HttpClient, rootUrl: string, params?: SaveGraphAnnotation$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphAnnotationModel>> {
  const rb = new RequestBuilder(rootUrl, SaveGraphAnnotation.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GraphAnnotationModel>;
    })
  );
}

SaveGraphAnnotation.PATH = '/api/Graph/SaveGraphAnnotation';
